"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunkFNPPNAGRcjs = require('./chunk-FNPPNAGR.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v2_2/vault/VaultV2_2.ts
var VaultV2_2 = (_class = class extends _chunkFNPPNAGRcjs.VaultV2_1 {
  static __initStatic() {this.version = _chunkNE5AG7IWcjs.DEX_VERSION.v2_2}
}, _class.__initStatic(), _class);



exports.VaultV2_2 = VaultV2_2;
//# sourceMappingURL=chunk-R5F56AVK.cjs.map